import { Injectable } from '@angular/core';
import { Action } from '@ngrx/store';
import { Merchant, FileObject, MerchantConfiguration, AccountModel, MerchantEmailConfig } from "../../models";
import { Query } from "../../services";
import { UnsafeAction } from "../../actions/UnsafeAction";

/* tslint:disable */
@Injectable()
export class MerchantActions {

	static SET_MERCHANT_LOGO = "[MERCHANT] Update merchant logo"
	public setMerchantLogo(fileObject : FileObject): UnsafeAction {
		return {
			type: MerchantActions.SET_MERCHANT_LOGO,
			payload: fileObject
		}
	}

	static UNSET_MERCHANT_LOGO = "[MERCHANT] usnet merchant logo"
	public unsetMerchantLogo(): Action{
		return {
			type: MerchantActions.UNSET_MERCHANT_LOGO
		}
	}
	static REMOVE_MERCHANT_LOGO = "[MERCHANT] remove merchant logo"
	public removeMerchantLogo(): Action{
		return {
			type: MerchantActions.REMOVE_MERCHANT_LOGO
		}
	}

	static SAVE_MERCHANT_LOGO = "[MERCHANT] save merchant logo"
	public saveMerchantLogo(): Action {
		return {
			type: MerchantActions.SAVE_MERCHANT_LOGO
		}
	}
	static SAVE_MERCHANT_LOGO_SUCCESS = "[MERCHANT] save merchant logo successful"
	public saveMerchantLogoSuccess(): Action {
		return {
			type: MerchantActions.SAVE_MERCHANT_LOGO_SUCCESS
		}
	}

	static DELETE_MERCHANT_LOGO_SUCCESS = "[MERCHANT] delete merchant logo successful"
	public deleteMerchantLogoSuccess(): Action {
		return {
			type: MerchantActions.DELETE_MERCHANT_LOGO_SUCCESS
		}
	}
	static SAVE_MERCHANT_CONFIG = "[MERCHANT] save merchant config"
	public saveMerchantConfig(merchantConfig: MerchantConfiguration): UnsafeAction{
		return {
			type: MerchantActions.SAVE_MERCHANT_CONFIG,
			payload: merchantConfig
		}
	}

	static SAVE_MERCHANT_CONFIG_SUCCESS = "[MERCHANT] save merchant config success"
	public saveMerchantConfigSuccess(merchant: Merchant): UnsafeAction{
		return {
			type: MerchantActions.SAVE_MERCHANT_CONFIG_SUCCESS,
			payload: merchant
		}
	}

	static LOAD_MERCHANT_LIST = "[MERCHANT] Load merchant list"
	public loadMerchantList(): Action {
		return {
			type: MerchantActions.LOAD_MERCHANT_LIST
		}
	}

	static LOAD_MERCHANT_LIST_SUCCESS = "[MERCHANT] Load merchant list success"
	public loadMerchantListSuccess(merchants): UnsafeAction{
		return {
			type: MerchantActions.LOAD_MERCHANT_LIST_SUCCESS,
			payload: merchants
		}
	}

	static LOAD_MERCHANT_BY_MERCHANT_ID = "[MERCHANT] Load Merchant by id"
	public loadMerchantByMerchantId(merchantId: string): UnsafeAction {
		return {
			type: MerchantActions.LOAD_MERCHANT_BY_MERCHANT_ID,
			payload: merchantId
		}
	}

	static LOAD_MERCHANT_BY_MERCHANT_ID_SUCCSESS = "[MERCHANT] Load Merchant by id success"
	public loadMerchantByMerchantIdSuccess(merchant: Merchant): UnsafeAction {
		return {
			type: MerchantActions.LOAD_MERCHANT_BY_MERCHANT_ID_SUCCSESS,
			payload: merchant
		}
	}

	static MERCHANT_LOADED = "[MERCHANT] Merchant loaded"
	public merchantLoaded(merchant: Merchant): UnsafeAction {
		return {
			type: MerchantActions.MERCHANT_LOADED,
			payload: merchant
		}
	}

	static LOAD_MERCHANT_ACCOUNTS = "[MERCHANT] Load Merchant Accounts"
	public loadMerchantAccounts(merchantId: String): UnsafeAction {
		return{
			type: MerchantActions.LOAD_MERCHANT_ACCOUNTS,
			payload: merchantId
		}
	}

	static LOAD_MERCHANT_ACCOUNTS_SUCCESS = "[MERCHANT] Load Merchant Accounts success"
	public loadMerchantAccountsSuccess(merchantAccounts: AccountModel[]): UnsafeAction {
		return{
			type: MerchantActions.LOAD_MERCHANT_ACCOUNTS_SUCCESS,
			payload: merchantAccounts
		}
	}

	static MERCHANT_ACCOUNT_LOADED = "[MERCHANT] MerchantAccount loaded"
	public merchantAccountLoaded(merchantAccount: AccountModel): UnsafeAction {
		return{
			type: MerchantActions.MERCHANT_ACCOUNT_LOADED,
			payload: merchantAccount
		}
	}

	static LOAD_MERCHANT_ACCOUNT_BY_ID = "[MERCHANT] Load Merchant Account by Id"
	public loadMerchantAccountById(accountId: string): UnsafeAction {
		return {
			type: MerchantActions.LOAD_MERCHANT_ACCOUNT_BY_ID,
			payload: accountId
		}
	}

	static LOAD_BOOKING_OFFICES = "[MERCHANT] Load BookingOffices"
	public loadBookingOffices(url: string) {
		return {
			type: MerchantActions.LOAD_BOOKING_OFFICES,
			payload: url
		}
	}
	static LOAD_BOOKING_OFFICES_SUCCESS = "loadBookingOfficesSuccess"
	public loadBookingOfficesSuccess(bookingOffices): UnsafeAction {
		return {
			type: MerchantActions.LOAD_BOOKING_OFFICES_SUCCESS,
			payload: bookingOffices
		}
	}

	static LOAD_MERCHANT_EMAIL_CONFIGS = "[MERCHANT] Load Merchant Email-Configs"
	public loadMerchantEmailConfigs(merchantId: String): UnsafeAction {
		return{
			type: MerchantActions.LOAD_MERCHANT_EMAIL_CONFIGS,
			payload: merchantId
		}
	}

	static LOAD_MERCHANT_EMAIL_CONFIGS_SUCCESS = "[MERCHANT] Load Merchant Email-Configs success"
	public loadMerchantEmailConfigsSuccess(merchantEmailConfigs: MerchantEmailConfig[]): UnsafeAction {
		return{
			type: MerchantActions.LOAD_MERCHANT_EMAIL_CONFIGS_SUCCESS,
			payload: merchantEmailConfigs,
		}
	}

	static SET_SELECTED_MERCHANT_EMAIL_CONFIG_UUID = "[MERCHANT] Set selected Merchant Email-Config UUID"
	public setSelectedMerchantEmailConfigUUID(uuid: string): UnsafeAction {
		return{
			type: MerchantActions.SET_SELECTED_MERCHANT_EMAIL_CONFIG_UUID,
			payload: uuid,
		}
	}
}



// WEBPACK FOOTER //
// ./src/app/components/merchants/merchant.actions.ts